module.exports = __webpack_public_path__ + "static/media/services-header.b099d60d.jpg";